import type { RevisionReusableContent } from '../types';
import { randomUUID } from '../utils';

export const DEFAULT_REUSABLE_CONTENT_TITLE = 'Untitled';

/**
 * Create a reusable content.
 */
export function createReusableContent(
    parts: Pick<RevisionReusableContent, 'title'> & Partial<RevisionReusableContent>
): RevisionReusableContent {
    return {
        ...parts,
        id: parts.id ?? randomUUID(),
        edits: parts.edits ?? {},
    };
}

/**
 * Create an empty reusable content.
 */
export function createEmptyReusableContent(
    title: string = DEFAULT_REUSABLE_CONTENT_TITLE
): RevisionReusableContent {
    return createReusableContent({ title });
}
